import { createContext, useState } from 'react';
import PropTypes from 'prop-types';

const initialState = {
    notifications: []
};

const NotifyContext = createContext({
    ...initialState,
    addNotify: () => {},
    removeNotify: () => {}
});

let notifyCount = 0;
export const NotifyProvider = ({ children }) => {
    const [notifications, setNotifications] = useState([]);

    const addNotify = (text, type = 'info', time = 5000) => {
        if (type !== 'success' && type !== 'info' && type !== 'warning' && type !== 'error') return;
        const notifyId = notifyCount;
        notifyCount++;
        setNotifications((state) => {
            return [...state, { text, type, time, id: notifyId }];
        });
        setTimeout(() => {
            removeNotify(notifyId);
        }, time);
    };

    const removeNotify = (id) => {
        setNotifications((current) => current.filter((notification) => notification.id !== id));
    };

    return (
        <NotifyContext.Provider
            value={{
                notifications,
                addNotify,
                removeNotify
            }}
        >
            {children}
        </NotifyContext.Provider>
    );
};

NotifyProvider.propTypes = {
    children: PropTypes.element
};

export default NotifyContext;
